// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* App.css */
/* App.css */

/* ---------- Base Reset ---------- */
*,
*::before,
*::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

:root {
  /* แบรนด์สีเดียวกับ Navbar/Sidebar */
  --brand: #078dee;
  --brand-2: #68cdf9;

  /* Glass token */
  --paper-glass: rgba(255, 255, 255, 0.14);
  --paper-glass-border: rgba(255, 255, 255, 0.35);
}

html,
body,
#root {
  height: 100%;
  min-height: 100%;
}

html {
  scroll-behavior: smooth;
}

body {
  color: #0f172a;
  /* Gradient พื้นหลังแบบ fixed + radial highlight โมเดิร์น */
  background:
    radial-gradient(1200px 800px at 85% -10%, rgba(255,255,255,.25), transparent 60%),
    radial-gradient(1000px 700px at -10% 100%, rgba(255,255,255,.18), transparent 60%),
    linear-gradient(120deg, rgba(7,141,238,0.96), rgba(40, 139, 181, 0.96));
  background-attachment: fixed;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* ---------- Utilities ---------- */

/* การ์ด/กล่องแบบกระจก ใช้กับ MUI <Paper className="glass-card" /> ได้เลย */
.glass-card {
  background: var(--paper-glass);
  border: 1px solid var(--paper-glass-border);
  backdrop-filter: saturate(160%) blur(10px);
  -webkit-backdrop-filter: saturate(160%) blur(10px);
  border-radius: 16px;
  box-shadow: 0 12px 30px rgba(7,141,238,0.08), 0 2px 10px rgba(0,0,0,0.06);
}

/* จัดให้อยู่กลางจอแบบ responsive (เผื่ออยากใช้แทน inline sx) */
.center-screen {
  min-height: calc(100svh - 64px);
  display: grid;
  place-items: center;
  padding: clamp(16px, 3vw, 32px);
}

/* เข้าหน้าแบบนุ่ม ๆ */
@keyframes fadeUp {
  from { opacity: 0; transform: translateY(8px); }
  to   { opacity: 1; transform: translateY(0); }
}
.fade-up {
  animation: fadeUp .4s ease both;
}

/* ---------- Modern Scrollbar (WebKit) ---------- */
*::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
*::-webkit-scrollbar-thumb {
  background: "rgba(255, 255, 255, 0.35)";
  border-radius: 10px;
}
*::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.35);
}

`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,YAAY;AACZ,YAAY;;AAEZ,qCAAqC;AACrC;;;EAGE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,kBAAkB;;EAElB,gBAAgB;EAChB,wCAAwC;EACxC,+CAA+C;AACjD;;AAEA;;;EAGE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,2DAA2D;EAC3D;;;2EAGyE;EACzE,4BAA4B;EAC5B,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA,oCAAoC;;AAEpC,2EAA2E;AAC3E;EACE,8BAA8B;EAC9B,2CAA2C;EAC3C,0CAA0C;EAC1C,kDAAkD;EAClD,mBAAmB;EACnB,yEAAyE;AAC3E;;AAEA,+DAA+D;AAC/D;EACE,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA,sBAAsB;AACtB;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;AACA;EACE,+BAA+B;AACjC;;AAEA,oDAAoD;AACpD;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,uCAAuC;EACvC,mBAAmB;AACrB;AACA;EACE,qCAAqC;AACvC","sourcesContent":["/* App.css */\n/* App.css */\n\n/* ---------- Base Reset ---------- */\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\n:root {\n  /* แบรนด์สีเดียวกับ Navbar/Sidebar */\n  --brand: #078dee;\n  --brand-2: #68cdf9;\n\n  /* Glass token */\n  --paper-glass: rgba(255, 255, 255, 0.14);\n  --paper-glass-border: rgba(255, 255, 255, 0.35);\n}\n\nhtml,\nbody,\n#root {\n  height: 100%;\n  min-height: 100%;\n}\n\nhtml {\n  scroll-behavior: smooth;\n}\n\nbody {\n  color: #0f172a;\n  /* Gradient พื้นหลังแบบ fixed + radial highlight โมเดิร์น */\n  background:\n    radial-gradient(1200px 800px at 85% -10%, rgba(255,255,255,.25), transparent 60%),\n    radial-gradient(1000px 700px at -10% 100%, rgba(255,255,255,.18), transparent 60%),\n    linear-gradient(120deg, rgba(7,141,238,0.96), rgba(40, 139, 181, 0.96));\n  background-attachment: fixed;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n/* ---------- Utilities ---------- */\n\n/* การ์ด/กล่องแบบกระจก ใช้กับ MUI <Paper className=\"glass-card\" /> ได้เลย */\n.glass-card {\n  background: var(--paper-glass);\n  border: 1px solid var(--paper-glass-border);\n  backdrop-filter: saturate(160%) blur(10px);\n  -webkit-backdrop-filter: saturate(160%) blur(10px);\n  border-radius: 16px;\n  box-shadow: 0 12px 30px rgba(7,141,238,0.08), 0 2px 10px rgba(0,0,0,0.06);\n}\n\n/* จัดให้อยู่กลางจอแบบ responsive (เผื่ออยากใช้แทน inline sx) */\n.center-screen {\n  min-height: calc(100svh - 64px);\n  display: grid;\n  place-items: center;\n  padding: clamp(16px, 3vw, 32px);\n}\n\n/* เข้าหน้าแบบนุ่ม ๆ */\n@keyframes fadeUp {\n  from { opacity: 0; transform: translateY(8px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n.fade-up {\n  animation: fadeUp .4s ease both;\n}\n\n/* ---------- Modern Scrollbar (WebKit) ---------- */\n*::-webkit-scrollbar {\n  width: 10px;\n  height: 10px;\n}\n*::-webkit-scrollbar-thumb {\n  background: \"rgba(255, 255, 255, 0.35)\";\n  border-radius: 10px;\n}\n*::-webkit-scrollbar-track {\n  background: rgba(255, 255, 255, 0.35);\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
